import {
  Box,
  TextField,
  Stack,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  FormHelperText,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateRangePickerLegacyProps } from './types';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR as ptBRAdapter } from 'date-fns/locale';

// ----------------------------------------------------------------------

export default function CustomDateRangePickerLegacy({
  title = 'Select date range',
  variant = 'input',
  //
  startDate,
  endDate,
  //
  onChangeStartDate,
  onChangeEndDate,
  //
  open,
  onClose,
  onApply,
  //
  error,
}: DateRangePickerLegacyProps) {
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={
        {
          // sx: {
          //   ...(isCalendarView && {
          //     maxWidth: 720,
          //   }),
          // },
        }
      }
    >
      <DialogTitle sx={{ pb: 2 }}>{title}</DialogTitle>

      <DialogContent>
        <Stack justifyContent="center" sx={{ pt: 1 }}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBRAdapter}>
            <DatePicker
              closeOnSelect
              label="Data de Início"
              value={startDate}
              onChange={onChangeStartDate}
              /* @ts-ignore */
              renderInput={(props: any) => <TextField {...props} />}
              inputFormat="dd/MM/yyyy"
              slotProps={{
                day: {
                  sx: {
                    '&.MuiPickersDay-root.Mui-selected': {
                      backgroundColor: 'primary.main',
                    },
                  },
                },
              }}
            />
            <Box height={24} />
            <DatePicker
              closeOnSelect
              label="Data de Fim"
              value={endDate}
              onChange={onChangeEndDate}
              /* @ts-ignore */
              renderInput={(props: any) => <TextField {...props} />}
              inputFormat="dd/MM/yyyy"
              slotProps={{
                day: {
                  sx: {
                    '&.MuiPickersDay-root.Mui-selected': {
                      backgroundColor: 'primary.main',
                    },
                  },
                },
              }}
            />
          </LocalizationProvider>
        </Stack>

        {error && (
          <FormHelperText error sx={{ px: 2 }}>
            Data de fim deve ser maior que a data de início
          </FormHelperText>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="inherit" onClick={onClose}>
          Cancelar
        </Button>

        <Button disabled={error} variant="contained" onClick={onApply}>
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
